<template>
  <div v-if="!!infoDialog">
    <component :is="infoDialog" v-model="modelValue" />
  </div>
</template>

<script>
import { Component, ComputedOptions } from 'vue'
import { Computed } from '@/_typedefs'
import HanifinAndRajkaDialog from '@/components/NewAttendanceForm/AtopicDermatitis/FormNodes/Dialogs/HanifinAndRajkaDialog.vue'
import VaccineDialog from '@/components/NewAttendanceForm/AtopicDermatitis/FormNodes/Dialogs/VaccineDialog.vue'

export default {
  name: 'InfoDialogActivatorComponent',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    info: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dialog: {
        info: false,
      },
    }
  },
  computed: {
    /** @type {ComputedOptions<boolean>} */
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    /** @type {Computed<Component | null>} */
    infoDialog() {
      if (!this.info) {
        return null
      }

      const dialogMap = {
        'atopic-dermatitis:hanifin-rajka': HanifinAndRajkaDialog,
        'atopic-dermatitis:vaccine': VaccineDialog,
      }

      return dialogMap[this.info] ?? null
    },
  },
}
</script>

<style></style>
